var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHarmony02C2E3Ba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 179.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 202.93,
    y1: 544.7,
    x2: 203.8,
    y2: 545.57,
    gradientTransform: "matrix(180, 0, 0, -179.51, -36456, 98005.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69fabd"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "harmony-one-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M201.17,60a38.81,38.81,0,0,0-38.84,38.71v42.92c-4,.27-8.09.44-12.33,0.44s-8.31.17-12.33,0.41V98.71a38.84,38.84,0,0,0-77.67,0V201.29a38.84,38.84,0,0,0,77.67,0V158.37c4-.27,8.09-0.44,12.33-0.44s8.31-.17,12.33-0.41v43.77a38.84,38.84,0,0,0,77.67,0V98.71A38.81,38.81,0,0,0,201.17,60ZM98.83,75.86a22.91,22.91,0,0,1,22.92,22.85v45.45a130.64,130.64,0,0,0-33,9.33,60,60,0,0,0-12.8,7.64V98.71A22.91,22.91,0,0,1,98.83,75.86Zm22.92,125.43a22.92,22.92,0,1,1-45.84,0V191c0-9.09,7.2-17.7,19.27-23.06a113,113,0,0,1,26.57-7.77v41.12Zm79.42,22.85a22.91,22.91,0,0,1-22.92-22.85V155.84a130.64,130.64,0,0,0,33-9.33,60,60,0,0,0,12.8-7.64v62.42A22.91,22.91,0,0,1,201.17,224.14ZM204.82,132a113,113,0,0,1-26.57,7.77V98.71a22.92,22.92,0,1,1,45.84,0V109C224.09,118.05,216.89,126.66,204.82,132Z",
    transform: "translate(-60 -60)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmony02C2E3Ba);
export default __webpack_public_path__ + "static/media/harmony.02c2e3ba.02c2e3bade8b31e4b6943850f5f55c2a.svg";
export { ForwardRef as ReactComponent };